import { render, staticRenderFns } from "./LeoOrderDetailW.vue?vue&type=template&id=0cdf1eb9&scoped=true&"
import script from "./LeoOrderDetailW.vue?vue&type=script&lang=js&"
export * from "./LeoOrderDetailW.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrderDetailW.vue?vue&type=style&index=0&id=0cdf1eb9&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf1eb9",
  null
  
)

export default component.exports